import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

function ManufacturerNumber ({
  localManufacturerNumber,
  setLocalManufacturerNumber,
  isQueryLoading
}) {
  const handleManufacturerNumber = event => {
    setLocalManufacturerNumber(event.target.value)
  }

  return (
    <div className={styles.manufacturerNumberContainer}>
      <div className={styles.inlineLabel}>
        <label
          className={styles.manufacturerNumberLabel}
          htmlFor='ManufacturerNumber'
        >
          Manufacturer / model number
        </label>
        <Tooltip
         title='Filter by the manufacturer’s identifier or model number.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Manufacturer / model number help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <input
        className={styles.manufacturerNumberInput}
        disabled={isQueryLoading}
        placeholder='Text'
        onChange={handleManufacturerNumber}
        value={localManufacturerNumber}
        type='text'
      />
    </div>
  )
}

export default ManufacturerNumber
